import React from 'react'
import {SvgIcon, SvgIconProps} from '@mui/material'

const AddAlertIconSvg = (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M16.7486 3.85712L20.1429 7.55997L19.5086 8.14283L16.1143 4.43997L16.7486 3.85712ZM6.39429 3.85712L3 7.55997L3.63429 8.14283L7.02857 4.43997L6.39429 3.85712ZM16.92 8.85426C17.6257 9.9126 18.0016 11.1565 18 12.4285V12.8571H18.8571V12.4285C18.8571 10.9876 18.4298 9.57895 17.6293 8.38082C16.8287 7.18269 15.6908 6.24886 14.3596 5.69742C13.0283 5.14598 11.5633 5.0017 10.1501 5.28282C8.73677 5.56394 7.43858 6.25784 6.41965 7.27677C5.40073 8.29569 4.70683 9.59388 4.42571 11.0072C4.14459 12.4205 4.28887 13.8854 4.84031 15.2167C5.39174 16.548 6.32557 17.6858 7.5237 18.4864C8.72183 19.287 10.1305 19.7143 11.5714 19.7143H12V18.8571H11.5714C10.4612 18.8562 9.37008 18.5678 8.40441 18.0199C7.43875 17.472 6.63144 16.6834 6.06112 15.7308C5.49079 14.7782 5.1769 13.6942 5.15 12.5843C5.12311 11.4743 5.38413 10.3764 5.90765 9.39729C6.43117 8.41821 7.19933 7.5914 8.13733 6.9974C9.07532 6.4034 10.1512 6.06246 11.2601 6.00778C12.369 5.9531 13.4731 6.18654 14.465 6.68538C15.4569 7.18421 16.3027 7.93143 16.92 8.85426Z"
            fill="currentColor"/>
        <path
            d="M11.1429 7.71429V12H8.57144V12.8572H12V7.71429H11.1429ZM16.2857 17.1429V13.7143H17.1429V17.1429H20.5714V18H17.1429V21.4286H16.2857V18H12.8572V17.1429H16.2857Z"
            fill="currentColor"/>
    </svg>
)


const AddAlertIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon {...props}>
        {AddAlertIconSvg}
    </SvgIcon>
)
export default AddAlertIcon